/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrchestrateBlobMetadata as StorageOrchestrateBlobMetadata } from '../../models/storage/orchestrate-blob-metadata';

export interface UploadBlob$Params {
      body: {
'storageStrategyName': string;
'accessData': string;
'linkData'?: string | null;
'file': Blob;
}
}

export function uploadBlob(http: HttpClient, rootUrl: string, params: UploadBlob$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageOrchestrateBlobMetadata>> {
  const rb = new RequestBuilder(rootUrl, uploadBlob.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<StorageOrchestrateBlobMetadata>;
    })
  );
}

uploadBlob.PATH = '/blob';

function reviveStorageOrchestrateBlobMetadata(value: any): any {
  if (value) {
    if (value["modified"] != null) {
      value["modified"] = parseDateTime(value["modified"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body != null) {
    body = reviveStorageOrchestrateBlobMetadata(body);
  }
  return body;
}
